
import { anonymous, isRegistered } from 'bits/user_model'
import { Component, namespace, Prop, Vue } from 'bits/vue'
import type { User } from 'types'
import AvatarImage from 'vuecomponents/avatar_image.vue'
import BaseIcon from 'vuecomponents/base_icon.vue'
import CsrfInput from 'vuecomponents/csrf_input.vue'
import ProgressDeterminate from 'vuecomponents/progress_determinate.vue'

const A_LOT_OF_WALLS = 10000

@Component({
  components: {
    AvatarImage,
    BaseIcon,
    CsrfInput,
    ProgressDeterminate,
  },
})
export default class UserMenu extends Vue {
  @Prop({ required: true }) user!: User

  @namespace('appBarAccount').Action hideUserMenu!: () => void
  @namespace('electronApp').Action logOut!: () => void

  get displayName(): string {
    return this.user.name || this.user.username || anonymous
  }

  get profileUrl(): string {
    return `/${this.user.username}`
  }

  get isPremium(): boolean {
    return this.user.paying
  }

  get wallsLimit(): number {
    // We add 2 because our actual walls limit is 2 above the advertized wall limit.
    return this.user.quota.walls_limit !== this.user.quota.advertized_walls_limit + 2
      ? this.user.quota.walls_limit
      : this.user.quota.advertized_walls_limit
  }

  get showQuota(): boolean {
    return this.wallsLimit < A_LOT_OF_WALLS
  }

  get quotaUsed(): number {
    return this.user.quota.walls_used / this.wallsLimit
  }

  get quotaUsageText(): string {
    return this.__('%{num} of %{limit} padlets used', {
      num: this.user.quota.walls_used,
      limit: this.wallsLimit,
    })
  }

  get quotaExcessUsageText(): string {
    return this.__('You have exceeded your padlet limit by %{excess}. Consider upgrading.', {
      excess: this.user.quota.walls_used - this.wallsLimit,
    })
  }

  get showReferrals(): boolean {
    return isRegistered(this.user)
  }

  get isNotNativeTenant(): boolean {
    return this.user.tenant_id !== 1
  }

  cancel(): void {
    this.hideUserMenu()
  }

  upgradePlan(): void {
    this.hideUserMenu()
    this.$emit('upgrade')
  }
}
